import React, {useState} from 'react';
import {Dropdown, Grid} from 'semantic-ui-react';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import _ from 'lodash';
import {formatDateMMDDYYYY, safeAdd, showDollarAmountWithDollar} from 'common/utils';
import {ASSOCIATED_ENTITY_STATUSES} from 'app-ui-componentlibrary/dist/common/constants';

export const ApplicationsTable = (props) => {
  const {
    applications,
    selectedColumn,
    sortDirection,
    setSelectedColumnProp,
    setSortDirectionProp,
    summary,
    doEntityAction,
    entityType,
  } = props;
  const [applicationsState, setApplications] = useState(applications);

  const columnsToHide = _.get(props, 'hideColumns', []);

  const handleColumnClick = (columnName) => {
    let direction = sortDirection == 'ASC' ? 'DESC' : 'ASC';
    setSelectedColumnProp(columnName);
    setSortDirectionProp(direction);
  };
  const getClassName = (columnName) =>
    `sorted${
      selectedColumn == columnName
        ? sortDirection == 'ASC'
          ? ' ascending'
          : ' descending'
        : ''
    }`;

  const renderActiveTabContents = () => {
    return (
      <Grid
        key={'applicationsGrid'}
        doubling
        stackable
        reversed="mobile"
        padded="vertically"
      >
        <Grid.Column style={{overflow:'auto'}}>
          <FemaGoTable
            summary={summary || 'Applications table'}
            type="static"
            columns="16"
            className="sortable"
          >
            <FemaGoTable.Header>
              <FemaGoTable.Row>
                {!_.includes(columnsToHide, 'orgName') ? (
                  <FemaGoTable.HeaderCell
                    title="Recipient"
                    onClick={() => handleColumnClick('orgName')}
                    className={getClassName('orgName')}
                  >
                    Recipient
                  </FemaGoTable.HeaderCell>
                ) : null}
                {!_.includes(columnsToHide, 'grantID') ? (
                  <FemaGoTable.HeaderCell
                    title="Grant ID"
                    onClick={() => handleColumnClick('grantID')}
                    className={getClassName('grantID')}
                  >
                    Grant ID
                  </FemaGoTable.HeaderCell>
                ) : null}
                {!_.includes(columnsToHide, 'fedShare') ? (
                  entityType == 'application' ? (
                    <FemaGoTable.HeaderCell
                      title="Requested federal share"
                      onClick={() => handleColumnClick('fedShare')}
                      className={getClassName('fedShare')}
                    >
                      Requested<br></br>federal share
                    </FemaGoTable.HeaderCell>
                  ) : (
                    <FemaGoTable.HeaderCell
                      title="Total federal share"
                      onClick={() => handleColumnClick('fedShare')}
                      className={getClassName('fedShare')}
                    >
                      Total<br></br>federal share
                    </FemaGoTable.HeaderCell>
                  )
                ) : null}
                {!_.includes(columnsToHide, 'status') ? (
                  <FemaGoTable.HeaderCell
                    title="Status of application"
                    onClick={() => handleColumnClick('status')}
                    className={getClassName('status')}
                  >
                    Status
                  </FemaGoTable.HeaderCell>
                ) : null}
                {!_.includes(columnsToHide, 'statusTimeStamp') ? (
                  <FemaGoTable.HeaderCell
                    title="Date of status"
                    onClick={() => handleColumnClick('statusTimeStamp')}
                    className={getClassName('statusTimeStamp')}
                  >
                    Status date
                  </FemaGoTable.HeaderCell>
                ) : null}
                {!_.includes(columnsToHide, 'actions') ? (
                  <FemaGoTable.HeaderCell title="Actions for application">
                    Actions
                  </FemaGoTable.HeaderCell>
                ) : null}
              </FemaGoTable.Row>
            </FemaGoTable.Header>
            <FemaGoTable.Body>
              {_.map(applicationsState, (app, index) => {
                const actions = _.get(app, 'actions', []);
                let showError = false;
                let errorMessages = [];
                return (
                  <FemaGoTable.Row
                    key={`${app.entityId}`}
                    errorMessages={errorMessages}
                    displayError={showError}
                  >
                    {!_.includes(columnsToHide, 'orgName') ? (
                      <FemaGoTable.TextCell>
                        {_.get(app.payload, 'orgName')}
                      </FemaGoTable.TextCell>
                    ) : null}
                    {!_.includes(columnsToHide, 'grantID') ? (
                      <FemaGoTable.TextCell>
                        <a href={'/grant/' + app.grantId} target="_blank">
                          {app.grantId}
                        </a>
                      </FemaGoTable.TextCell>
                    ) : null}
                    {!_.includes(columnsToHide, 'fedShare') ? (
                      <FemaGoTable.TextCell>
                        {showDollarAmountWithDollar(
                          safeAdd(..._.get(app.payload, 'budget.share.fedShare', []))
                        )}
                      </FemaGoTable.TextCell>
                    ) : null}
                    {!_.includes(columnsToHide, 'status') ? (
                      <FemaGoTable.TextCell>{`${
                        ASSOCIATED_ENTITY_STATUSES[app.status]
                      }`}</FemaGoTable.TextCell>
                    ) : null}
                    {!_.includes(columnsToHide, 'statusTimeStamp') ? (
                      <FemaGoTable.TextCell>
                        {formatDateMMDDYYYY(_.get(app, 'statusTimestamp'))}
                      </FemaGoTable.TextCell>
                    ) : null}
                    {!_.includes(columnsToHide, 'actions') ? (
                      <FemaGoTable.TextCell>
                        {!_.isEmpty(actions) ? (
                          <Dropdown
                            selectOnNavigation={false}
                            selectOnBlur={false}
                            text={'Actions'}
                            name={`${app.entityId}-action-button`}
                            id={`${app.entityId}-action-button`}
                            onChange={(e, {name, value}) => doEntityAction(value, app)}
                            options={actions}
                            direction="left"
                            value={''}
                          />
                        ) : null}
                      </FemaGoTable.TextCell>
                    ) : null}
                  </FemaGoTable.Row>
                );
              })}
            </FemaGoTable.Body>
          </FemaGoTable>
        </Grid.Column>
      </Grid>
    );
  };

  return <>{renderActiveTabContents()}</>;
};

export default connectDynamic(ApplicationsTable);
